import React from "react";
import Lottie from "lottie-react";
import animationData from "./page-loader.json";

const PageLoader = () => {
    return (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-20 z-50">
            <Lottie
                animationData={animationData}
                loop={true}
                style={{ width: 100, height: 100 }}
            />
        </div>
    );
};

export default PageLoader;
